import { render, staticRenderFns } from "./CodeBox.vue?vue&type=template&id=3b7789be&"
import script from "./CodeBox.vue?vue&type=script&lang=js&"
export * from "./CodeBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports